import type { EChartsOption } from 'echarts';

export type RegbrMetricKey =
  | 'complexidade-linguistica'
  | 'influencia-industria'
  | 'popularidade'
  | 'restritividade';

export interface RegbrMetricNavItem {
  key: RegbrMetricKey;
  labelKey: string;
}

export const REGBR_METRIC_KEYS: RegbrMetricKey[] = [
  'complexidade-linguistica',
  'influencia-industria',
  'popularidade',
  'restritividade',
];

export const REGBR_METRIC_NAV: RegbrMetricNavItem[] = [
  {
    key: 'complexidade-linguistica',
    labelKey: 'pages.regbr.metrics.options.complexity',
  },
  {
    key: 'influencia-industria',
    labelKey: 'pages.regbr.metrics.options.influence',
  },
  {
    key: 'popularidade',
    labelKey: 'pages.regbr.metrics.options.popularity',
  },
  {
    key: 'restritividade',
    labelKey: 'pages.regbr.metrics.options.restrictiveness',
  },
];

export type RegbrGroupBy = 'agencia_reguladora' | 'tipo_lei' | 'setor';

export interface RegbrFilterOption {
  label: string;
  value: string;
  items?: RegbrFilterOption[];
}

export interface RegbrChartParams {
  agrupador: RegbrGroupBy;
  agencias: string[];
  tiposLei: string[];
  setores: string[];
  situacoes: string[];
}

export type RegbrChartOption = EChartsOption | null;
